/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_PriorityInputs */

const en_group_priority = /** @type {(inputs: Group_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const de_group_priority = /** @type {(inputs: Group_PriorityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priorität`)
};

/**
* | output |
* | --- |
* | "Priority" |
*
* @param {Group_PriorityInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const group_priority = /** @type {((inputs?: Group_PriorityInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_PriorityInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_group_priority(inputs)
	return en_group_priority(inputs)
});